import { render, staticRenderFns } from "./WaWidget.vue?vue&type=template&id=5be177c3&scoped=true&"
import script from "./WaWidget.vue?vue&type=script&lang=js&"
export * from "./WaWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be177c3",
  null
  
)

export default component.exports